function PrivacyPolicy() {
    return (
        <div className="privacy-policy">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> March 14, 2025</p>
    
        <h2>1. Introduction</h2>
        <p>This Privacy Policy describes how File Transfer ("we", "us", or "our") handles user data when you use our mobile application ("App"). We respect your privacy and ensure that no user or device information is collected, shared, or stored.</p>
    
        <h2>2. App Information</h2>
        <ul>
            <li><strong>App Name:</strong> File Transfer</li>
            <li><strong>App Description:</strong> A file-sharing application that runs an HTTP server for local network file transfers.</li>
            <li><strong>App Functionality:</strong> Allows users to transfer files through a locally hosted HTTP server.</li>
            <li><strong>Target Audience:</strong> General users</li>
            <li><strong>Supported Platforms:</strong> Android</li>
            <li><strong>Available Regions:</strong> Worldwide</li>
        </ul>
    
        <h2>3. Data Collection and Usage</h2>
        <p>We do not collect, store, or share any personally identifiable information, device information, or user behavior data.</p>
        <p>The application only facilitates file transfer over a local network and does not interact with external servers or third-party services.</p>
    
        <h2>4. Data Security</h2>
        <p>The App does not transmit any user data over the internet. It only operates within the local network for file transfers. Since we do not store any data, there is no risk of unauthorized access to personal information.</p>
    
        <h2>5. Children's Privacy</h2>
        <p>Our App does not collect any personal data from users, including children. It is safe for use by individuals of all ages.</p>
    
        <h2>6. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. If changes occur, we will notify users by updating this page. We encourage users to review this Privacy Policy periodically.</p>
    
        <h2>7. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
        <p><strong>Email:</strong> shiva.v2232@gmail.com</p>
        </div>
    );
}

export default PrivacyPolicy;